import { AxiosResponse } from 'axios';
import qs from 'qs';
import { appContextDelete, appContextGet, appContextPost, appContextPut } from './httpCommon/appAxios.service';
import { EMBRYOSTRAW_API_ENDPOINTS } from '../constants/apiEndpoints';
import { EmbryoStraw, StandardParams } from '../types/interfaces';
import { ExistingEmbryoStrawDataPayload } from '../types/interfaces/addStrawLevelData.interfaces';

export const getEmbryoStraws = (params?: StandardParams): Promise<AxiosResponse<any[], any>> => {
  return appContextGet(EMBRYOSTRAW_API_ENDPOINTS.EMBRYOSTRAWS, undefined, {
    paramsSerializer: (p: Record<string, any>) => qs.stringify(p, { arrayFormat: 'repeat' }),
    params,
  });
};

export const updateEmbryoStraws = (embryoStraws: Partial<EmbryoStraw>[]): Promise<AxiosResponse<any, any>> => {
  return appContextPut(EMBRYOSTRAW_API_ENDPOINTS.EMBRYOSTRAWS, embryoStraws);
};

export const upsertEmbryoStraws = (
  embryoStraws: Partial<EmbryoStraw>[],
  specimenId: number,
): Promise<AxiosResponse<any, any>> => {
  return appContextPut(EMBRYOSTRAW_API_ENDPOINTS.EMBRYOSTRAWS_ + specimenId + EMBRYOSTRAW_API_ENDPOINTS.UPSERT, embryoStraws, {
    specimenId,
  });
};

export const deleteEmbryoStraws = (strawIds: number[]): Promise<AxiosResponse<{}, any>> => {
  return appContextDelete(EMBRYOSTRAW_API_ENDPOINTS.EMBRYOSTRAWS, {}, strawIds);
};

export const getEmbryoStrawsByInventoryTransaction = (
  inventoryTransactionId: number,
  accountId: number,
): Promise<AxiosResponse<EmbryoStraw[], any>> => {
  const url = `${EMBRYOSTRAW_API_ENDPOINTS.GET_BY_INVENTORY_TRANSACTION}/${inventoryTransactionId}`;
  return appContextGet(url, { accountId });
};

export const saveExistingEmbryoStrawData = (payload: ExistingEmbryoStrawDataPayload[]): Promise<AxiosResponse<any, any>> => {
  return appContextPost(EMBRYOSTRAW_API_ENDPOINTS.EMBRYOSTRAWS + EMBRYOSTRAW_API_ENDPOINTS.SAVE_EXISTING_STRAW_DATA, payload);
};
